import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ActionCreator } from '@ngrx/store';
import { tap } from 'rxjs/operators';
import { ListQueryService } from './list-query.service';

/**
 * Builds the standard "invalidate this list's keyed cache on mutation" effect.
 * A mutation can change what any page of the list contains, so the matching
 * {@link ListQueryService} entries are marked stale (active ones refetch).
 *
 * Assign it as an effect field so @ngrx/effects registers it. The `actions$`/
 * `listQuery` are passed as thunks so the factory can run in a field
 * initializer (mirroring how effects defer `this.actions$`):
 *
 * ```ts
 * invalidateListQueries$ = listInvalidationEffect(
 *   () => this.actions$, () => this.listQuery,
 *   CONSULTATION_LIST_QUERY_PREFIX,
 *   [Actions.saveConsultationSuccess, Actions.updateConsultationSuccess]
 * );
 * ```
 */
export function listInvalidationEffect(
  getActions: () => Actions,
  getListQuery: () => ListQueryService,
  prefix: string,
  triggers: ActionCreator[]
) {
  return createEffect(
    () =>
      getActions().pipe(
        ofType(...triggers),
        tap(() => getListQuery().invalidate(prefix))
      ),
    { dispatch: false }
  );
}
